import React from 'react';
import { useWatchlist } from '../useContext/WatchlistContext';

const WatchlistTest = () => {
  const { watchlist, favorites, addToWatchlist, addToFavorites, getWatchlistCount, getFavoritesCount } = useWatchlist();

  const testMovie = {
    id: 550,
    title: 'Fight Club',
    type: 'movie',
    poster_path: '/pB8BM7pdSp6B6Ih7QZ4DrQ3PmJK.jpg',
    imgSrc: 'https://image.tmdb.org/t/p/w500/pB8BM7pdSp6B6Ih7QZ4DrQ3PmJK.jpg',
    vote_average: 8.4,
    release_date: '1999-10-15',
    overview: 'A ticking-time-bomb insomniac and a slippery soap salesman channel primal male aggression into a shocking new form of therapy.',
    adult: false
  };

  const handleAddToWatchlist = () => {
    addToWatchlist(testMovie);
  };

  const handleAddToFavorites = () => {
    addToFavorites(testMovie);
  };

  return (
    <div className="container mt-5">
      <h2>Watchlist Test</h2>
      <div className="row">
        <div className="col-md-6">
          <div className="card">
            <div className="card-body">
              <h5 className="card-title">Test Movie</h5>
              <p className="card-text">{testMovie.title}</p>
              <button onClick={handleAddToWatchlist} className="btn btn-primary me-2">
                Add to Watchlist
              </button>
              <button onClick={handleAddToFavorites} className="btn btn-danger">
                Add to Favorites
              </button>
            </div>
          </div>
        </div>
        <div className="col-md-6">
          <div className="card">
            <div className="card-body">
              <h5 className="card-title">Current State</h5>
              <p>Watchlist Count: {getWatchlistCount()}</p>
              <p>Favorites Count: {getFavoritesCount()}</p>
              <p>Watchlist Items: {watchlist.length}</p>
              <p>Favorites Items: {favorites.length}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WatchlistTest;
